import { render, staticRenderFns } from "./DialogWindow.vue?vue&type=template&id=726d593e&scoped=true&"
import script from "./DialogWindow.vue?vue&type=script&lang=js&"
export * from "./DialogWindow.vue?vue&type=script&lang=js&"
import style0 from "./DialogWindow.vue?vue&type=style&index=0&id=726d593e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726d593e",
  null
  
)

component.options.__file = "DialogWindow.vue"
export default component.exports